import 'reflect-metadata'
import { define, type, auto, Record, Store } from 'type-r'
import { restfulIO } from 'type-r/endpoints/restful'

@define
export default class SiteStore extends Store {
    static endpoint = restfulIO('/checkdt');

    @auto(null) declare currdt: bigint
    @auto('') declare configdt: string
    @auto('') declare caption: string
    @auto('') declare token: string
    @auto(true) declare freeversion: boolean
    @auto(false) declare embedversion: boolean
    @type(Boolean).value(false).as declare sendmodal: boolean
    @type(Boolean).value(false).events({'change': 'goReload'}).as declare reload: boolean
    @auto('4.500') declare selCpn: string
    @auto('') declare startCpn: string
    @auto(2) declare selIdx: number
    @auto([]) declare fnmaCoupons: string[]
    @auto(1) declare choice: number
    @auto(null) declare rr: any
    @type(null).as declare msgs: any
    @type(Date).value(new Date()).as declare date: any // calendar / agenda date ref
    @auto('') declare mmsg: string
    
    parse(data?:any) {
        if (data?.fj) {
            data.token = data.fj;
            delete data.fj;
        }
        if (data?.startCpn && !data.selCpn) {
            data.selCpn = data.startCpn.split(/\s/).pop();
        }
        return data;
    }

    async checkDt(): Promise<void> {
        window.setTimeout(() => this.checkDt(), 60 * 1000);
        await this.fetch({params: {fj: this.token, dt: this.currdt, type: 'checkdt'}});
        if (!this.freeversion)
            await this.updateMsgs();
    }

    updateMsgs(): void {
        $.ajax('/msgs').done(function (response) {
            $('.message-menu').html(response);
        });
    }

    goReload() {
        window.location.reload();
    }
}

const store = window.store = new SiteStore();
export { store };
